import script from "./document-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./document-upload.vue?vue&type=script&setup=true&lang=ts"

import "./document-upload.vue?vue&type=style&index=0&id=4ee1ba60&lang=scss"

const __exports__ = script;

export default __exports__